module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome-page common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box content-wrap scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "quick-nav"
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, _vm._l((_vm.menuNav), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 4
      }
    }, [_c('router-link', {
      staticClass: "item",
      attrs: {
        "to": item.MoUrl
      }
    }, [_c('div', {
      staticClass: "vm-cotar"
    }, [_vm._v(_vm._s(item.MoName))])])], 1)
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "contact-info-wrap"
  }, [_c('table', {
    staticClass: "contact-info-tab"
  }, [_c('tbody', {
    staticClass: "contact-info"
  }, [_c('WelcomeForm', {
    ref: "popForm",
    on: {
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-bar"
  }, [_vm._v("\n      Note! The system browser is recommended to run: IE9 or more:\n      "), _c('a', {
    staticClass: "down-link",
    attrs: {
      "href": "https://www.baidu.com/link?url=4eO8r116y7VARgZMmtD5BCAEp06bHehAK4a9m2l_BDgmyJxkTfv8NEDDwhN797O4CE86SCEJwoYmOrHIhVTSi359id0geXzoDsPdRuVe09C&wd=&eqid=d3c069f80002a6d9000000035719f91e",
      "target": "_blank"
    }
  }, [_vm._v("Google Chrome ,")]), _vm._v(" "), _c('a', {
    staticClass: "down-link",
    attrs: {
      "href": "https://www.baidu.com/link?url=dUrZ_7TO3Aw0T7Li31vES6hcLmjkP7DxhF3pKLSxClhR7R4FX16LLdPqaR6wGCjugB_EgBgh5Pfh8UPreifyDBgi-LB3JBr5n4yH1vaS9ty&wd=&eqid=e3103e1b00001f250000000359bfca00",
      "target": "_blank"
    }
  }, [_vm._v("Firefox browser")]), _vm._v("\n      In order to achieve the best operating results\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f1442d40","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/common/Welcome.vue
// module id = 800
// module chunks = 1